'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindVideoEvents;

var _Injection = require('./Injection');

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2016, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 * @providesModule bindVideoEvents
 */

function bindVideoEvents(video, playerId) {
  var requiredPlayerId = playerId || Object.keys(_store2.default.storeInstance().getState().players)[0];
  var listenerMap = (0, _Injection.getListenerMap)();

  /*
   * flush any injected event listeners by custom components
   */
  var playerQueue = listenerMap[requiredPlayerId];
  if (playerQueue) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = playerQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var injectedListener = _step.value;

        video.addEventListener(injectedListener.event, injectedListener.callback);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  var preVideoPlayerQueue = listenerMap.NO_PLAYER_READY || [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = preVideoPlayerQueue[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _injectedListener = _step2.value;

      video.addEventListener(_injectedListener.event, _injectedListener.callback);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}
module.exports = exports['default'];